<a
  class="lien-evitement"
  [href]="'#' + cible()"
  (click)="allerAuContenu($event)"
  >{{ 'A11Y.SKIP_TO_CONTENT' | translate }}</a
>
